module.exports={
    btn:{
        tips_reelect_btn:"Νέα εικόνα",
        cancel_btn:"Ματαίωση",
        tips_continue_dispose:"Αναβαθμισμένες υποστηριζόμενες εικόνες",
        tips_return:"Νέα εικόνα",
        tips_upgrade:"Αναβαθμίζω",
        tips_yes:"ΕΝΤΑΞΕΙ",
        delete:"Διαγράφω",
        download:"Κατεβάστε",
        upload_image:"Μεταφόρτωση εικόνας",
        new_image:"Νέα εικόνα",
        save_all:"Αποθήκευση όλων",
        cancel:"Ακύρωση",
        save:"Αποθηκεύσετε",
        view_comparison:"Προβολή σύγκρισης",
        hide_comparison:"Απόκρυψη σύγκρισης",
        previous:"Προηγούμενος",
        next:"Επόμενο",
        continue_download:"Αποθήκευση εικόνων με υδατογραφήματα",
        present:"Εφαρμογή σε αυτήν την εικόνα",
        all_wait:"Εφαρμογή στις εικόνες σε αναμονή",
        all:"Εφαρμογή σε όλες τις εικόνες",
        history:"Ιστορία",
        login:"Σύνδεση",
    },
    tips:{
        please_upgrade:"Το τρέχον σχέδιό σας δεν υποστηρίζει τη μεταφόρτωση ή την αναβάθμιση εικόνων κατά παρτίδες. Αναβαθμίστε το για να απολαμβάνετε περισσότερα οφέλη.",
        errorlistinfo:"Επιλέγονται XXX εικόνες. Οι εικόνες XXX υποστηρίζονται, αλλά οι εικόνες XXX δεν υποστηρίζονται. Οι παρακάτω εικόνες είναι μη υποστηριζόμενες:",
        max:"Υπέρβαση του μέγιστου ορίου μεγέθους εικόνας των 10 MB!",
        max_size:"Υπέρβαση του μέγιστου ορίου μήκους πλευράς εικόνας των 4096 εικονοστοιχείων!",
        continue_dispose:"Αναβαθμισμένες υποστηριζόμενες εικόνες",
        please_multiple:"Επιλέξτε τη μεγέθυνση",
        max_multiple:"* Η εικόνα σας θα μεγεθύνεται σε 4K το πολύ (η μεγαλύτερη πλευρά δεν θα υπερβαίνει τα 4096 px).",
        title:"Ονομα",
        reasons:"Αιτιολογικό",
        upload_type:"Δεν υποστηρίζεται",
        used_up:"Ο αριθμός των αποθηκευμένων εικόνων HD χωρίς υδατογραφήματα έχει εξαντληθεί. Αναβαθμίστε τον λογαριασμό σας. Ή μπορείτε να αποθηκεύσετε εικόνες HD με υδατογραφήματα.",
        edit_multiple:"Έχουν μεταφορτωθεί πολλές εικόνες. Επιλέξτε τις εικόνες που θέλετε να αλλάξετε τη μεγέθυνση. Μετά την επιλογή, αυτές οι εικόνες θα αναβαθμιστούν ξανά στη νέα μεγέθυνση.",
        download_confirm:"Ορισμένες εικόνες βρίσκονται ακόμη υπό επεξεργασία. Είστε βέβαιοι ότι θα αποθηκεύσετε όλες τις αναβαθμισμένες εικόνες; Όταν αποθηκεύετε την ίδια εικόνα επανειλημμένα, ο αριθμός των αποθηκευμένων εικόνων δεν θα αφαιρεθεί ξανά.",
        waiting_save:"Ορισμένες εικόνες βρίσκονται ακόμη υπό επεξεργασία. Αποθηκεύστε αργότερα.",
        
    },
    header:{
        title:"AnyMP4 Image Upscaler Online",
        hd:" εικόνα(εις) HD",
        watermarks:"χωρίς υδατογραφήματα μπορεί να γίνει λήψη προς το παρόν.",
        view_details:"Δείτε λεπτομέρειες",
        loading:"Φόρτωση…",
    },
    content:{
        failed:"Απέτυχε",
        completed:"Ολοκληρώθηκε το",
        processing:"Επεξεργασία",
        img_processing:"Επεξεργασία…",
        img_failed:"Απέτυχε η επεξεργασία",
        uploading:"Μεταφόρτωση",
        img_uploading:"Μεταφόρτωση…",
        wait_upoading:"Αναμονή για μεταφόρτωση…",
        waiting:"Αναμονή",
        img_waiting:"Αναμονή…",
        empty:"Αδειάζω",
        magnification:"Μεγέθυνση:",
        drop:"Ή αποθέστε το αρχείο εικόνας σας εδώ για αναβάθμιση και βελτίωση! ",
        original:"Πρωτότυπο:",
        output:"Παραγωγή:",
    },
    banner_msg:"Επιλέξτε ένα σχέδιο για το Image Upscaler",
    monthly:"ΜΗΝΙΑΙΟ",
    lifetime:"ΔΙΑΡΚΕΙΑ ΖΩΗΣ",
    choose_plan:"Επιλέξτε το σχέδιό σας με βάση τον αριθμό των εικόνων",
    return_home:"Συγχαρητήρια! Αναβαθμίσατε με επιτυχία. Επιστρέψτε στην αρχική σελίδα και χρησιμοποιήστε αυτό το προϊόν.",
    congratulations:"Συγχαρητήρια! Αναβαθμίσατε με επιτυχία. Τα πλεονεκτήματα έχουν δεσμευτεί στη διεύθυνση ηλεκτρονικού ταχυδρομείου που αφήσατε κατά την αναβάθμιση. Χρησιμοποιήστε τον λογαριασμό που είναι καταχωρημένος ή συνδεδεμένος με τη διεύθυνση ηλεκτρονικού ταχυδρομείου στο",
    login_benefits:"συνδεθείτε για να χρησιμοποιήσετε τα οφέλη",
    no_registered:". Εάν δεν έχετε εγγραφεί ή δεν έχετε συνδέσει λογαριασμό με τη διεύθυνση ηλεκτρονικού ταχυδρομείου",
    register_account:"χρησιμοποιήστε τη διεύθυνση e-mail για να καταχωρήσετε έναν λογαριασμό",
    other_accounts:" ή συνδέστε άλλους λογαριασμούς σε αυτήν τη διεύθυνση ηλεκτρονικού ταχυδρομείου για χρήση των προνομίων.",
    btn_close:"Κλείσε",
    free:"Ελεύθερος",
    btn_get_started:"Ξεκίνα",
    // access_to:"Πρόσβαση σε",
    upscale_images:"Πολυτελείς εικόνες",
    up_to:"Μέχρι και ",
    per_image:" ανά εικόνα",
    resolution_of:"Μέχρι την ανάλυση του",
    default_level:"Αναβαθμίστε τις εικόνες σε προεπιλεγμένο επίπεδο",
    image_downloads:"2 λήψεις εικόνων HD χωρίς υδατογράφημα",
    unlimited_image:"Απεριόριστες λήψεις εικόνων με υδατογράφημα",
    SHA256_encryption:"Τεχνική κρυπτογράφησης SHA256",
    mon:"Μηνιαίο",
    images:"εικόνες",
    high_resolution:" με ποιότητα υψηλής ανάλυσης",
    tax_incl:"Συμπεριλαμβανομένου του φόρου",
    image:"εικόνα",
    secure_checkout:"Ασφαλής ολοκλήρωση αγοράς",
    everything:"Τα πάντα δωρεάν και",
    upscaling_levels:"Μπορούν να επιλεγούν όλα τα επίπεδα αναβάθμισης",
    unlimited_image_without:"Απεριόριστες λήψεις εικόνων χωρίς υδατογράφημα",
    viewable_editing:"Το ιστορικό επεξεργασίας με δυνατότητα προβολής ισχύει για",
    days:" ημέρες",
    high_level:"Υψηλό επίπεδο",
    priority_processing:" επεξεργασία κατά προτεραιότητα",
    left:"Διάρκεια Ζωής",
    resolution:" ανάλυση",


    "history_will":"Θα λήξει μετά",
    "history.days":"Ημέρες)",
    "history.hours":"ώρες",
    "expired":"έχει λήξει",
    "access_to":"Με τη δωρεάν δοκιμή μπορείτε μόνο",
    "pricing.upload_images":"Ανεβάστε εικόνες",
    "pricing.under":"κάτω από",
    "pricing.images":"εικόνες",
    "pricing.without_watermark":"χωρίς υδατογράφημα",
    "pricing.process_images":"Επεξεργασία εικόνων μέχρι",
    "pricing.pixels":"εικονοστοιχεία",
    "pricing.enjoy_limited":"Απολαύστε περιορισμένους ποιοτικούς βαθμούς",
    "pricing.download":"Κατεβάστε",
    "pricing.HD_images":"Εικόνες HD χωρίς υδατογράφημα",
    "pricing.and_you":"Και μπορεί να υποφέρετε από",
    "pricing.slow_upscaling":"αργή αναβάθμιση",
    "pricing.lower_priority":"χαμηλότερης προτεραιότητας",
    "pricing.without":"χωρίς υδατοσήμανση",
    "pricing.tax":"Ο φόρος περιλαμβάνεται στην τιμή πώλησης και θα υπολογιστεί αυτόματα με βάση τη χώρα και την περιοχή σας. Στο καλάθι αγορών μπορείτε να δείτε το αναλυτικό ποσό φόρου. Το τελικό ποσό πληρωμής σας θα είναι το ίδιο με την τιμή που εμφανίζεται.",
    "pricing.you_can":"Με συνδρομή μπορείτε",
    "pricing.up_to":"Μεταφόρτωση εικόνων έως",
    "pricing.upscale_images":"Αναβαθμισμένες εικόνες με",
    "pricing.no_watermark":"χωρίς υδατογράφημα",
    "pricing.enhance":"Ενισχύω",
    "pricing.or_more":"εικόνες ή περισσότερες",
    "pricing.in_batch":"σε παρτίδα",
    "pricing.enlarge_images":"Μεγέθυνση εικόνων σε",
    "pricing.and":"και",
    "pricing.times_with":"φορές χωρίς όριο",
    "pricing.enjoy":"Απολαμβάνω",
    "pricing.of_history":"του χρόνου αποθήκευσης της ιστορίας",
    "pricing.experience":"Εμπειρία",
    "pricing.fast_upscaling":"γρήγορη αναβάθμιση",
    "pricing.higher_priority":"υψηλότερη προτεραιότητα",
    "pricing.early_access":"Πρώιμη πρόσβαση σε νέες δυνατότητες",
    "pricing.cancel_anytime":"Ακύρωση ανά πάσα στιγμή",
    "pricing.lifetime_license":"Με ισόβια άδεια μπορείτε",
    "pricing.and_there":"Και θα υπάρξει",
    "pricing.no_expiration":"χωρίς ημερομηνία λήξης",
    "pricing.unless":"εκτός αν εξαντλήσετε όλα τα πολυτελή",
}